export default __webpack_public_path__ + "static/CircularStd-Black-ad902a1255e5abec6db959a64e71c849.ttf";